export const VALIDATION_RULES = {
  UPLOAD_FILE_SIZE_BYTES: 5242880, // 5MB
  UPLOAD_FILES_TOTAL_SIZE_BYTES: 5242880, // 5MB
  UPLOAD_FILES_AMOUNT_LIMIT: 1,
  UPLOAD_FILE_ALLOWED_TYPES: ['pdf', 'png', 'jpg', 'jpeg', 'doc', 'docx'],
};
